// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.work-reports-list {
  width: 100%;
}

.work-reports-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 30px;
}

.work-reports-header h2 {
  margin: 0;
  color: #333;
  font-size: 1.8rem;
}

.create-report-btn {
  display: flex;
  align-items: center;
  gap: 8px;
  background: var(--ar-buttons-bg);
  color: var(--main-text-color);
  border: none;
  padding: 12px 20px;
  border-radius: 8px;
  font-weight: 500;
  cursor: pointer;
  transition: background 0.3s;
}

.create-report-btn:hover {
  background: var(--secondary-color);
}

.pdf-btn {
  background: #dc3545 !important;
}

.pdf-btn:hover {
  background: #c82333 !important;
}

/* Full screen modal styles */
.modal-overlay.full-screen {
  z-index: 9999;
}

.modal-content.full-screen-content {
  width: 100vw;
  height: 100vh;
  max-width: none;
  max-height: none;
  margin: 0;
  border-radius: 0;
  padding: 0;
}

/* Filters */
.work-reports-filters {
  display: flex;
  gap: 16px;
  margin-bottom: 24px;
  flex-wrap: wrap;
}

.filter-select {
  padding: 10px 14px;
  border: 1px solid #ddd;
  border-radius: 6px;
  font-size: 14px;
  background: white;
  cursor: pointer;
}

.filter-select:focus {
  outline: none;
  border-color: var(--secondary-color);
}

/* Reports Grid */
.reports-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(350px, 1fr));
  gap: 20px;
}

.report-card {
  background: white;
  border: 1px solid #e0e0e0;
  border-radius: 12px;
  padding: 24px;
  transition: all 0.3s;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}

.report-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.12);
  border-color: var(--secondary-color);
}

.report-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 20px;
  padding-bottom: 16px;
  border-bottom: 1px solid #f0f0f0;
}

.report-header h3 {
  margin: 0;
  color: #2c3e50;
  font-size: 1.3rem;
  font-weight: 600;
  flex: 1 1;
}

.report-actions {
  display: flex;
  gap: 8px;
  flex-shrink: 0;
}

.action-btn {
  background: white;
  border: 1px solid #e0e0e0;
  padding: 8px;
  border-radius: 6px;
  cursor: pointer;
  color: #666;
  transition: all 0.2s;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
}

.action-btn:hover {
  background: #f8f9fa;
  transform: scale(1.05);
}

.action-btn svg {
  font-size: 20px;
}

.view-btn:hover {
  color: var(--main-text-color-highligth);
  border-color: var(--main-text-color-highligth);
}

.edit-btn:hover {
  color: #FF9800;
  border-color: #FF9800;
}

.delete-btn:hover {
  color: #F44336;
  border-color: #F44336;
}

.pdf-btn:hover {
  color: #dc3545;
  border-color: #dc3545;
}

.excel-btn:hover {
  color: #217346;
  border-color: #217346;
}

.report-meta {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  margin-bottom: 16px;
  align-items: center;
}

.status-badge {
  color: white;
  padding: 6px 12px;
  border-radius: 16px;
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.work-type {
  background: #f0f0f0;
  color: #666;
  padding: 6px 12px;
  border-radius: 16px;
  font-size: 12px;
  font-weight: 500;
}

.date {
  font-size: 13px;
  color: #666;
  display: flex;
  align-items: center;
  gap: 4px;
}

.sent-by {
  font-size: 13px;
  color: #666;
  display: flex;
  align-items: center;
  gap: 4px;
}

.report-description {
  color: #666;
  margin: 0 0 16px 0;
  line-height: 1.6;
  font-size: 14px;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

.report-details {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  padding-top: 12px;
  border-top: 1px solid #f0f0f0;
}

.report-details span {
  font-size: 13px;
  color: #666;
  display: flex;
  align-items: center;
  gap: 6px;
  font-weight: 500;
}

/* No Reports */
.no-reports {
  text-align: center;
  padding: 60px 20px;
  color: #666;
}

.no-reports h3 {
  margin: 0 0 12px 0;
  font-size: 1.3rem;
}

.no-reports p {
  margin: 0 0 24px 0;
}

.create-first-report-btn {
  background: var(--ar-buttons-bg);
  color: var(--main-text-color);
  border: none;
  padding: 12px 24px;
  border-radius: 8px;
  font-weight: 500;
  cursor: pointer;
  transition: background 0.3s;
}

.create-first-report-btn:hover {
  background: var(--secondary-color);
}

/* Modal */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 20px;
}

.modal-content {
  background: white;
  border-radius: 16px;
  width: 100%;
  max-width: 1200px;
  max-height: 95vh;
  overflow-y: auto;
}

.details-modal {
  max-width: 800px;
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 24px;
  border-bottom: 1px solid #e0e0e0;
}

.modal-header h2 {
  margin: 0;
  color: #333;
}

.close-btn {
  background: none;
  border: none;
  font-size: 24px;
  color: #666;
  cursor: pointer;
  padding: 4px;
  line-height: 1;
}

.close-btn:hover {
  color: #333;
}

.report-details-content {
  padding: 24px;
}

.detail-row {
  display: grid;
  grid-template-columns: 150px 1fr;
  gap: 16px;
  margin-bottom: 16px;
  align-items: start;
}

.detail-row strong {
  color: #555;
  font-weight: 600;
}

.detail-row span {
  color: #333;
  word-break: break-word;
}

.images-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
  gap: 12px;
  margin-top: 8px;
}

.report-image {
  width: 100%;
  height: 120px;
  object-fit: cover;
  border-radius: 8px;
  border: 1px solid #e0e0e0;
}

.loading {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 200px;
  color: #666;
}

/* Mobile Responsive */
@media (max-width: 768px) {
  .work-reports-header {
    flex-direction: column;
    gap: 16px;
    align-items: stretch;
  }
  
  .work-reports-filters {
    flex-direction: column;
  }
  
  .filter-select {
    width: 100%;
  }
  
  .reports-grid {
    grid-template-columns: 1fr;
  }
  
  .report-header {
    flex-direction: column;
    gap: 12px;
    align-items: stretch;
  }
  
  .report-actions {
    align-self: flex-end;
  }
  
  .modal-content {
    margin: 10px;
    max-height: calc(100vh - 20px);
  }
  
  .detail-row {
    grid-template-columns: 1fr;
    gap: 4px;
  }
  
  .images-grid {
    grid-template-columns: repeat(auto-fill, minmax(120px, 1fr));
  }
}`, "",{"version":3,"sources":["webpack://./src/components/project/WorkReportsList.css"],"names":[],"mappings":"AAAA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gCAAgC;EAChC,6BAA6B;EAC7B,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA,6BAA6B;AAC7B;EACE,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,SAAS;EACT,gBAAgB;EAChB,UAAU;AACZ;;AAEA,YAAY;AACZ;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,oCAAoC;AACtC;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,oBAAoB;EACpB,yCAAyC;AAC3C;;AAEA;EACE,2BAA2B;EAC3B,0CAA0C;EAC1C,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,mBAAmB;EACnB,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,SAAS;EACT,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,SAAO;AACT;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,WAAW;EACX,oBAAoB;EACpB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,uCAAuC;EACvC,8CAA8C;AAChD;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,eAAe;EACf,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;AAClB;;AAEA,eAAe;AACf;EACE,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gCAAgC;EAChC,6BAA6B;EAC7B,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,kCAAkC;AACpC;;AAEA,UAAU;AACV;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,SAAS;EACT,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,WAAW;EACX,eAAe;EACf,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,SAAS;EACT,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,WAAW;AACb;;AAEA,sBAAsB;AACtB;EACE;IACE,sBAAsB;IACtB,SAAS;IACT,oBAAoB;EACtB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,sBAAsB;IACtB,SAAS;IACT,oBAAoB;EACtB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,YAAY;IACZ,8BAA8B;EAChC;;EAEA;IACE,0BAA0B;IAC1B,QAAQ;EACV;;EAEA;IACE,4DAA4D;EAC9D;AACF","sourcesContent":[".work-reports-list {\r\n  width: 100%;\r\n}\r\n\r\n.work-reports-header {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  margin-bottom: 30px;\r\n}\r\n\r\n.work-reports-header h2 {\r\n  margin: 0;\r\n  color: #333;\r\n  font-size: 1.8rem;\r\n}\r\n\r\n.create-report-btn {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n  background: var(--ar-buttons-bg);\r\n  color: var(--main-text-color);\r\n  border: none;\r\n  padding: 12px 20px;\r\n  border-radius: 8px;\r\n  font-weight: 500;\r\n  cursor: pointer;\r\n  transition: background 0.3s;\r\n}\r\n\r\n.create-report-btn:hover {\r\n  background: var(--secondary-color);\r\n}\r\n\r\n.pdf-btn {\r\n  background: #dc3545 !important;\r\n}\r\n\r\n.pdf-btn:hover {\r\n  background: #c82333 !important;\r\n}\r\n\r\n/* Full screen modal styles */\r\n.modal-overlay.full-screen {\r\n  z-index: 9999;\r\n}\r\n\r\n.modal-content.full-screen-content {\r\n  width: 100vw;\r\n  height: 100vh;\r\n  max-width: none;\r\n  max-height: none;\r\n  margin: 0;\r\n  border-radius: 0;\r\n  padding: 0;\r\n}\r\n\r\n/* Filters */\r\n.work-reports-filters {\r\n  display: flex;\r\n  gap: 16px;\r\n  margin-bottom: 24px;\r\n  flex-wrap: wrap;\r\n}\r\n\r\n.filter-select {\r\n  padding: 10px 14px;\r\n  border: 1px solid #ddd;\r\n  border-radius: 6px;\r\n  font-size: 14px;\r\n  background: white;\r\n  cursor: pointer;\r\n}\r\n\r\n.filter-select:focus {\r\n  outline: none;\r\n  border-color: var(--secondary-color);\r\n}\r\n\r\n/* Reports Grid */\r\n.reports-grid {\r\n  display: grid;\r\n  grid-template-columns: repeat(auto-fill, minmax(350px, 1fr));\r\n  gap: 20px;\r\n}\r\n\r\n.report-card {\r\n  background: white;\r\n  border: 1px solid #e0e0e0;\r\n  border-radius: 12px;\r\n  padding: 24px;\r\n  transition: all 0.3s;\r\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);\r\n}\r\n\r\n.report-card:hover {\r\n  transform: translateY(-4px);\r\n  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.12);\r\n  border-color: var(--secondary-color);\r\n}\r\n\r\n.report-header {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: flex-start;\r\n  margin-bottom: 20px;\r\n  padding-bottom: 16px;\r\n  border-bottom: 1px solid #f0f0f0;\r\n}\r\n\r\n.report-header h3 {\r\n  margin: 0;\r\n  color: #2c3e50;\r\n  font-size: 1.3rem;\r\n  font-weight: 600;\r\n  flex: 1;\r\n}\r\n\r\n.report-actions {\r\n  display: flex;\r\n  gap: 8px;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.action-btn {\r\n  background: white;\r\n  border: 1px solid #e0e0e0;\r\n  padding: 8px;\r\n  border-radius: 6px;\r\n  cursor: pointer;\r\n  color: #666;\r\n  transition: all 0.2s;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  width: 36px;\r\n  height: 36px;\r\n}\r\n\r\n.action-btn:hover {\r\n  background: #f8f9fa;\r\n  transform: scale(1.05);\r\n}\r\n\r\n.action-btn svg {\r\n  font-size: 20px;\r\n}\r\n\r\n.view-btn:hover {\r\n  color: var(--main-text-color-highligth);\r\n  border-color: var(--main-text-color-highligth);\r\n}\r\n\r\n.edit-btn:hover {\r\n  color: #FF9800;\r\n  border-color: #FF9800;\r\n}\r\n\r\n.delete-btn:hover {\r\n  color: #F44336;\r\n  border-color: #F44336;\r\n}\r\n\r\n.pdf-btn:hover {\r\n  color: #dc3545;\r\n  border-color: #dc3545;\r\n}\r\n\r\n.excel-btn:hover {\r\n  color: #217346;\r\n  border-color: #217346;\r\n}\r\n\r\n.report-meta {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  gap: 12px;\r\n  margin-bottom: 16px;\r\n  align-items: center;\r\n}\r\n\r\n.status-badge {\r\n  color: white;\r\n  padding: 6px 12px;\r\n  border-radius: 16px;\r\n  font-size: 11px;\r\n  font-weight: 600;\r\n  text-transform: uppercase;\r\n  letter-spacing: 0.5px;\r\n}\r\n\r\n.work-type {\r\n  background: #f0f0f0;\r\n  color: #666;\r\n  padding: 6px 12px;\r\n  border-radius: 16px;\r\n  font-size: 12px;\r\n  font-weight: 500;\r\n}\r\n\r\n.date {\r\n  font-size: 13px;\r\n  color: #666;\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 4px;\r\n}\r\n\r\n.sent-by {\r\n  font-size: 13px;\r\n  color: #666;\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 4px;\r\n}\r\n\r\n.report-description {\r\n  color: #666;\r\n  margin: 0 0 16px 0;\r\n  line-height: 1.6;\r\n  font-size: 14px;\r\n  overflow: hidden;\r\n  display: -webkit-box;\r\n  -webkit-line-clamp: 2;\r\n  -webkit-box-orient: vertical;\r\n}\r\n\r\n.report-details {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  gap: 16px;\r\n  padding-top: 12px;\r\n  border-top: 1px solid #f0f0f0;\r\n}\r\n\r\n.report-details span {\r\n  font-size: 13px;\r\n  color: #666;\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 6px;\r\n  font-weight: 500;\r\n}\r\n\r\n/* No Reports */\r\n.no-reports {\r\n  text-align: center;\r\n  padding: 60px 20px;\r\n  color: #666;\r\n}\r\n\r\n.no-reports h3 {\r\n  margin: 0 0 12px 0;\r\n  font-size: 1.3rem;\r\n}\r\n\r\n.no-reports p {\r\n  margin: 0 0 24px 0;\r\n}\r\n\r\n.create-first-report-btn {\r\n  background: var(--ar-buttons-bg);\r\n  color: var(--main-text-color);\r\n  border: none;\r\n  padding: 12px 24px;\r\n  border-radius: 8px;\r\n  font-weight: 500;\r\n  cursor: pointer;\r\n  transition: background 0.3s;\r\n}\r\n\r\n.create-first-report-btn:hover {\r\n  background: var(--secondary-color);\r\n}\r\n\r\n/* Modal */\r\n.modal-overlay {\r\n  position: fixed;\r\n  top: 0;\r\n  left: 0;\r\n  right: 0;\r\n  bottom: 0;\r\n  background: rgba(0, 0, 0, 0.5);\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  z-index: 1000;\r\n  padding: 20px;\r\n}\r\n\r\n.modal-content {\r\n  background: white;\r\n  border-radius: 16px;\r\n  width: 100%;\r\n  max-width: 1200px;\r\n  max-height: 95vh;\r\n  overflow-y: auto;\r\n}\r\n\r\n.details-modal {\r\n  max-width: 800px;\r\n}\r\n\r\n.modal-header {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  padding: 20px 24px;\r\n  border-bottom: 1px solid #e0e0e0;\r\n}\r\n\r\n.modal-header h2 {\r\n  margin: 0;\r\n  color: #333;\r\n}\r\n\r\n.close-btn {\r\n  background: none;\r\n  border: none;\r\n  font-size: 24px;\r\n  color: #666;\r\n  cursor: pointer;\r\n  padding: 4px;\r\n  line-height: 1;\r\n}\r\n\r\n.close-btn:hover {\r\n  color: #333;\r\n}\r\n\r\n.report-details-content {\r\n  padding: 24px;\r\n}\r\n\r\n.detail-row {\r\n  display: grid;\r\n  grid-template-columns: 150px 1fr;\r\n  gap: 16px;\r\n  margin-bottom: 16px;\r\n  align-items: start;\r\n}\r\n\r\n.detail-row strong {\r\n  color: #555;\r\n  font-weight: 600;\r\n}\r\n\r\n.detail-row span {\r\n  color: #333;\r\n  word-break: break-word;\r\n}\r\n\r\n.images-grid {\r\n  display: grid;\r\n  grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));\r\n  gap: 12px;\r\n  margin-top: 8px;\r\n}\r\n\r\n.report-image {\r\n  width: 100%;\r\n  height: 120px;\r\n  object-fit: cover;\r\n  border-radius: 8px;\r\n  border: 1px solid #e0e0e0;\r\n}\r\n\r\n.loading {\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  height: 200px;\r\n  color: #666;\r\n}\r\n\r\n/* Mobile Responsive */\r\n@media (max-width: 768px) {\r\n  .work-reports-header {\r\n    flex-direction: column;\r\n    gap: 16px;\r\n    align-items: stretch;\r\n  }\r\n  \r\n  .work-reports-filters {\r\n    flex-direction: column;\r\n  }\r\n  \r\n  .filter-select {\r\n    width: 100%;\r\n  }\r\n  \r\n  .reports-grid {\r\n    grid-template-columns: 1fr;\r\n  }\r\n  \r\n  .report-header {\r\n    flex-direction: column;\r\n    gap: 12px;\r\n    align-items: stretch;\r\n  }\r\n  \r\n  .report-actions {\r\n    align-self: flex-end;\r\n  }\r\n  \r\n  .modal-content {\r\n    margin: 10px;\r\n    max-height: calc(100vh - 20px);\r\n  }\r\n  \r\n  .detail-row {\r\n    grid-template-columns: 1fr;\r\n    gap: 4px;\r\n  }\r\n  \r\n  .images-grid {\r\n    grid-template-columns: repeat(auto-fill, minmax(120px, 1fr));\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
